import { FaRegCircle, FaRegCircleCheck } from "react-icons/fa6";

export const CurrentSwitch = ({ status }) => {

    return status == 1 ? <FaRegCircleCheck color='green' size={20} /> : <FaRegCircle color='gray' size={20} />;

};